<app-navbar-style-one></app-navbar-style-one>

<!-- <div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>my Cart </h2>
                    <p class="mt-4 mb-0 mx-3">Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div> -->

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'my Cart' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="cart-section mt-5">
    <div class="cart-container">
        <div class="cart-content row">
            <!-- Left side - Cart items -->
            <div class="cart-items col-12">
                <div class="row px-2 " *ngIf="!isLoading"> <!--gap-2-->
                    <div class="cart-item col-lg-4 col-md-6 col-sm-12" *ngFor="let item of cartItems; let i = index">
                        <div class="item-image mx-auto text-center">
                            <img [src]="item.avatar || 'assets/images/default-food.png'" alt="{{item.name}}">
                            <div class="price-container">
                                <span *ngIf="item.offer" class="original-price">
                                    ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <span class="final-price" [class.discounted]="item.offer">
                                    ${{getItemPrice(item) | number:'1.2-2'}}
                                </span>
                                <!-- Show item total (unit price * quantity) -->
                                <!-- <div class="item-total" style="font-size: 0.9em; color: #666;">
                                    Total: ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                </div> -->
                            </div>
                            <span *ngIf="item.offer" class="discount-badge">
                                {{getItemDiscountText(item)}}
                            </span>
                        </div>

                        
                        <div class="item-details text-center">
                            <h3>{{item.name}}</h3>
                            
                            <!-- Display components and size -->
                             <p class="description-orgiginal">
                                <span>{{item.components}}</span>
                            </p>
                            <p class="description mb-0">
                                <!-- <span>{{item.components}}</span> -->
                                <span *ngIf="item.selectedTypeId" class="size-label ms-0">
                                    <span class="description mb-0">Type: </span>
                                    <span *ngFor="let selectedType of item.types">
                                        <span *ngIf="selectedType.id == item.selectedTypeId" style="color: #E2292C;">{{selectedType.name}}</span>
                                    </span>
                                    <!-- ({{item.selectedTypeId == item.types.id }}) -->
                                </span>
                            </p>

                            <!-- Display sides -->
                            <div *ngIf="item.selectedFreeSides && item.selectedFreeSides.length > 0">
                                <span class="description mb-0">Free Sides: </span>
                                <span class="mt-0" *ngFor="let side of item.selectedFreeSides; let last = last" style="color: #E2292C;">
                                    {{ side.name }}<span *ngIf="!last">, </span>
                                </span>
                            </div>
                            
                            <!-- Display unique extras with quantities -->
                            <!-- <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <span class="description mb-0">Extras: </span>
                                <span class="mt-0" *ngFor="let extra of getUniqueExtrasWithCount(item); let last = last" style="color: #c71d1d;">
                                    {{ extra.name }}<span *ngIf="extra.count > 1"> ({{ extra.count }}x)</span><span *ngIf="!last">, </span>
                                </span>
                            </div> -->
                            <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                <span class="description mb-0">Extras: </span>
                                <span class="mt-0" *ngFor="let extra of item.selectedExtraId; let last = last" style="color: #E2292C;">
                                    {{ extra.name }}<span *ngIf="extra.quantity > 1"> ({{ extra.quantity }}x)</span><span *ngIf="!last">, </span>
                                </span>
                            </div>
                            
                            <!-- Price and quantity with discount display -->
                            <div class="price-quantity ">
                                <!-- <div class="price-container">
                                    <span *ngIf="item.offer" class="original-price">
                                        ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span class="final-price" [class.discounted]="item.offer">
                                        ${{getItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span *ngIf="item.offer" class="discount-badge">
                                        {{getItemDiscountText(item)}}
                                    </span>
                                    Show item total (unit price * quantity)
                                    <div class="item-total" style="font-size: 0.9em; color: #666;">
                                        Total: ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                    </div>
                                </div> -->

                                
                                <div class="item-actions">
                                    <button class="quantity-btn" (click)="decreaseQuantity(i)" 
                                            [disabled]="item.quantity <= 1">-</button>
                                    <span class="quantity">{{item.quantity}}</span>
                                    <button class="quantity-btn" (click)="increaseQuantity(i)">+</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-center">
                            <button class="delete-btn" (click)="removeItem(i)">
                                <i class="bx bx-trash"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Custom Cart Items -->
                    <div class="cart-item col-lg-4 col-md-6 col-sm-12" *ngFor="let customItem of cartCustomProducts; let i = index">
                        <div class="item-image mx-auto">
                            <img [src]="getCustomProductImage(customItem)" alt="Custom Product">
                            <div class="price-container">
                                <span class="final-price">
                                    ${{getCustomProductPrice(customItem) | number:'1.2-2'}}
                                </span>
                            </div>
                        </div>

                        <div class="item-details text-center">
                            <h3>{{getCustomProductName(customItem)}}</h3>
                            
                            <!-- Size information -->
                            <p class="description mb-0" *ngIf="getCustomProductSize(customItem)">
                                <span class="size-label ms-0">
                                    <span class="description mb-0">Size: </span>
                                    <span style="color: #c71d1d;">{{getCustomProductSize(customItem)}}</span>
                                </span>
                            </p>

                            <!-- Half and Half indicator -->
                            <p class="description mb-0" *ngIf="isHalfAndHalf(customItem)">
                                <span style="color: #c71d1d; font-weight: bold;">Half & Half</span>
                            </p>

                            <!-- Ingredients Display -->
                            <div class="ingredients-section mt-2" *ngIf="!isHalfAndHalf(customItem)">
                                <span class="description mb-0">Ingredients: </span>
                                <div class="ingredients-list">
                                    <span *ngFor="let ingredient of getAllIngredients(customItem); let last = last" style="color: #c71d1d;">
                                        {{formatIngredientDisplay(ingredient)}}<span *ngIf="!last">, </span>
                                    </span>
                                </div>
                            </div>

                            <!-- Half and Half Ingredients Display -->
                            <div class="half-half-section mt-2" *ngIf="isHalfAndHalf(customItem)">
                                <div class="row">
                                    <div class="col-6">
                                        <span class="description">Left Half:</span>
                                        <div class="ingredients-list">
                                            <span *ngFor="let ingredient of getLeftHalfIngredients(customItem); let last = last" style="color: #c71d1d; display: block;">
                                                {{formatIngredientDisplay(ingredient)}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <span class="description">Right Half:</span>
                                        <div class="ingredients-list">
                                            <span *ngFor="let ingredient of getRightHalfIngredients(customItem); let last = last" style="color: #c71d1d; display: block;">
                                                {{formatIngredientDisplay(ingredient)}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="price-quantity">
                                <span class="quantity-display">Qty: {{customItem.quantity}}</span>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button class="delete-btn" (click)="removeCustomItem(i)">
                                <i class="bx bx-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Loading state -->
                <div class="account-card text-center row" *ngIf="isLoading">
                    <div class="spinner-grow" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <!-- Empty cart state -->
                <div class="alert alert-danger text-center row" *ngIf="cartItems.length === 0 && cartCustomProducts.length === 0 && !isLoading">
                    <div class="item-image">
                        <img src="../../../../assets/img/home2/empty-cart.png" width="200" alt="Empty Cart">
                    </div>
                    
                    <div class="item-details">
                        <h3>Your cart is empty</h3>
                        <p class="description">You haven't added any items to your cart yet.</p>
                    </div>
                </div>

                <div class="cart-summary col-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="summary-section payment-methods">
                                <h3 class="ms-3"><img src="../../../../assets/img/home2/cashless-payment.svg" class="me-2">Payment Method</h3>
                                <div class="payment-option d-flex align-items-center">
                                    <input type="radio" id="card" name="payment" [(ngModel)]="paymentMethod" (ngModelChange)="changePayment('card')" value="card">
                                    <label style="font-size: 18px;" for="card">Card</label>
                                </div>
                                <div class="payment-option d-flex align-items-center">
                                    <input type="radio" id="cash" name="payment" [(ngModel)]="paymentMethod" (ngModelChange)="changePayment('cash')" value="cash">
                                    <label style="font-size: 18px;" for="cash">Cash</label>
                                </div>
                                <!-- <div class="payment-option d-flex align-items-center">
                                    <input type="radio" id="card" name="payment" [(ngModel)]="paymentMethod" value="Card">
                                    <label style="font-size: 18px;" for="card">Card</label>
                                </div>
                                <div class="payment-option d-flex align-items-center">
                                    <input type="radio" id="Cash" name="payment" disabled="true" style="cursor: not-allowed;" [(ngModel)]="paymentMethod" value="Cash">
                                    <label style="font-size: 18px;cursor: not-allowed;" for="Cash">Cash (Comming Soon)</label>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="summary-section coupon-section">
                                <h3 class="mb-4 ms-3"><img src="../../../../assets/img/home2/voucher.svg" class="me-2">Coupon</h3>
                                <div class="coupon-input">
                                    <input type="text" placeholder="Enter coupon code" [(ngModel)]="couponCode">
                                    <button (click)="applyCoupon()">Apply</button>
                                </div>
                                <p class="coupon-message text-success" *ngIf="couponApplied">
                                    Coupon applied! 
                                    <span *ngIf="couponType === 'percentage'">{{couponValue}}% discount</span>
                                    <span *ngIf="couponType === 'value'">${{couponValue | number:'1.2-2'}} off</span>
                                </p>
                                <p *ngIf="couponApplied">
                                    <a class="text-danger" href="javascript:void(0)" (click)="removeCoupon()">Remove Coupon</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    

                    
                </div>

                <!-- Totals section -->
                <div class="total-section">
                    <div class="total-row">
                        <span>Subtotal:</span>
                        <span>${{subtotal | number:'1.2-2'}}</span>
                    </div>
                    <div class="total-row" *ngIf="cartDiscount > 0">
                        <span>Items Discount:</span>
                        <span class="text-danger">- ${{cartDiscount | number:'1.2-2'}}</span>
                    </div>
                    <div class="total-row" *ngIf="couponApplied">
                        <span>Coupon Discount:</span>
                        <span class="text-danger">
                            <span *ngIf="couponType === 'percentage'">- ${{subtotal * (couponValue / 100) | number:'1.2-2'}}</span>
                            <span *ngIf="couponType === 'value'">- ${{couponValue | number:'1.2-2'}}</span>
                        </span>
                    </div>
                    <div class="total-row grand-total">
                        <span>Total:</span>
                        <span>${{total | number:'1.2-2'}}</span>
                    </div>
                </div>
            </div>

            <!-- Right side - Payment and summary -->
            <!-- <div class="cart-summary col-12">
                <div class="summary-section payment-methods">
                    <h3>Payment</h3>
                    <div class="payment-option d-flex align-items-center">
                        <input type="radio" id="card" name="payment" [(ngModel)]="paymentMethod" value="Card">
                        <label style="font-size: 18px;" for="card">Card</label>
                    </div>
                </div>

                <div class="summary-section coupon-section">
                    <h3 class="mb-4">Coupon</h3>
                    <div class="coupon-input">
                        <input type="text" placeholder="Enter coupon code" [(ngModel)]="couponCode">
                        <button (click)="applyCoupon()">Apply</button>
                    </div>
                    <p class="coupon-message text-success" *ngIf="couponApplied">
                        Coupon applied! 
                        <span *ngIf="couponType === 'percentage'">{{couponValue}}% discount</span>
                        <span *ngIf="couponType === 'value'">${{couponValue | number:'1.2-2'}} off</span>
                    </p>
                    <p *ngIf="couponApplied">
                        <a class="text-danger" href="javascript:void(0)" (click)="removeCoupon()">Remove Coupon</a>
                    </p>
                </div>
            </div> -->
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button [disabled]="cartItemsLength == 0" class="checkout-btn" (click)="proceedToCheckout()">
               <i style="font-size: 20px;" class="bx bx-cart"></i> Proceed To Checkout
            </button>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>